module.exports = __webpack_public_path__ + "static/media/icon_location_water.590431ff.png";